import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Button, Divider, Upload, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const FormImagesResto = ({ onSubmit, isSaving, onExit, beforeUpload, handleCancelImageProfile, handlePreviewImageProfile, handleChangeImageProfile, fileListProfile, previewImageProfile, previewVisibleImageProfile, handleCancelImageSlider, handlePreviewImageSlider, handleChangeImageSlider, fileListSlider, previewImageSlider, previewVisibleImageSlider }) => {

    const dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
          onSuccess("ok");
        }, 0);
    };

    const uploadButton = () => (
        <div>
          <PlusOutlined />
          <div className="ant-upload-text">Agregar</div>
        </div>
    );

    /*const normFile = e => {
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
    };*/

    return (
        <Grid>
            <Form onFinish={onSubmit}>
                <Divider>Fotos</Divider>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Perfil" name="imageProfile">
                            <Upload
                            name="slider"
                            fileList={fileListProfile}
                            accept="image/*"
                            multiple={false}
                            listType="picture-card"
                            customRequest={dummyRequest}
                            beforeUpload={beforeUpload}
                            onPreview={handlePreviewImageProfile}
                            onChange={handleChangeImageProfile}
                            >
                                {fileListProfile.length >= 1 ? null : uploadButton()}
                            </Upload>
                            <Modal visible={previewVisibleImageProfile} footer={null} onCancel={handleCancelImageProfile}>
                                <img alt="images" style={{ width: '100%' }} src={previewImageProfile} />
                            </Modal>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Slider" name="imageSlider">
                            <Upload
                            name="slider"
                            fileList={fileListSlider}
                            accept="image/*"
                            multiple={true}
                            listType="picture-card"
                            customRequest={dummyRequest}
                            beforeUpload={beforeUpload}
                            onPreview={handlePreviewImageSlider}
                            onChange={handleChangeImageSlider}
                            >
                                {fileListSlider.length >= 10 ? null : uploadButton()}
                            </Upload>
                            <Modal visible={previewVisibleImageSlider} footer={null} onCancel={handleCancelImageSlider}>
                                <img alt="images" style={{ width: '100%' }} src={previewImageSlider} />
                            </Modal>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <Col xs={12} sm={5} md={4}>
                        <Row center="xs" start="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        isSaving ?
                                            <Button type="primary" htmlType="submit" disabled={true} loading>
                                                Guardando
                                            </Button>
                                            :
                                            <Button type="primary" htmlType="submit">
                                                Guardar
                                            </Button>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={2} md={4}></Col>
                    <Col xs={12} sm={5} md={4}>
                        <Row center="xs" end="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        <Button disabled={isSaving} onClick={onExit}>
                                            Cancelar
                                        </Button>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Grid>
    );
};

FormImagesResto.propTypes = {
    
};

export default FormImagesResto;